import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Profile() {
  const { handle } = useParams();
  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-8 grid gap-6 md:grid-cols-[1fr_320px]">
      <Helmet>
        <title>{handle ? `${handle} | FANZ Profile` : "Profile | FANZ"}</title>
        <meta name="description" content="Creator profile with gallery, badges, and booking." />
        <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : 'https://example.com/p/handle'} />
      </Helmet>

      <section className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle>Gallery</CardTitle>
          </CardHeader>
          <CardContent className="grid grid-cols-2 md:grid-cols-3 gap-2">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="bg-muted aspect-square rounded-md" />
            ))}
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Similar Profiles</CardTitle>
          </CardHeader>
          <CardContent className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <Card key={i} className="aspect-[3/4]" />
            ))}
          </CardContent>
        </Card>
      </section>

      <aside className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle>Book / Contact</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm text-muted-foreground">
            <div>Availability module</div>
            <div>Rates module</div>
          </CardContent>
        </Card>
        <Card className="sticky top-4">
          <CardHeader>
            <CardTitle>Sidebar Ad</CardTitle>
          </CardHeader>
          <CardContent className="aspect-[1/1] bg-muted rounded-md" />
        </Card>
      </aside>
    </main>
  );
}
